<app-confirm-pop-up-skeleton>
    <div content>{{popUpData.message}}</div>
</app-confirm-pop-up-skeleton>
